import React from "react";
import { Box, Link, Text } from "@opendoor/bricks-next";
import styled from "@emotion/styled";
//#region src/AccountForm/AccountFormCinderblocks/shared.tsx
/**
* Versioned marketing SMS consent language registry.
*
* All surfaces that display marketing SMS consent copy should import
* MARKETING_SMS_CONSENT from here.
*/
var CONSENT_VERSIONS = { marketing_sms_v1: {
	checkboxLabel: "I consent to receive marketing calls and texts from Opendoor and its affiliates to the number provided. I understand that I may opt out at any time and consent is not a condition of purchase.",
	ctaAgreement: (ctaText) => `By pressing \u201c${ctaText},\u201d I agree to Opendoor\u2019s Terms of Service and Privacy Policy.`,
	full: (ctaText) => `I consent to receive marketing calls and texts from Opendoor and its affiliates to the number provided. I understand that I may opt out at any time and consent is not a condition of purchase. By pressing \u201c${ctaText},\u201d I agree to Opendoor\u2019s Terms of Service and Privacy Policy.`,
	CtaAgreementLinked: ({ ctaText, tosAnalyticsName, privacyAnalyticsName, tosUrl = "https://www.opendoor.com/w/terms", privacyUrl = "https://www.opendoor.com/w/privacy", linkProps = {} }) => /* @__PURE__ */ React.createElement(React.Fragment, null, "By pressing “", ctaText, ",” I agree to Opendoor’s", " ", /* @__PURE__ */ React.createElement(Link, {
		analyticsName: tosAnalyticsName,
		href: tosUrl,
		target: "_blank",
		rel: "noopener noreferrer",
		"aria-label": "Opens a new page with Opendoor’s terms of service",
		onPress: () => {},
		...linkProps
	}, "Terms of Service"), " ", "and", " ", /* @__PURE__ */ React.createElement(Link, {
		analyticsName: privacyAnalyticsName,
		href: privacyUrl,
		target: "_blank",
		rel: "noopener noreferrer",
		"aria-label": "Opens a new page with Opendoor’s privacy policy",
		onPress: () => {},
		...linkProps
	}, "Privacy Policy"), ".")
} };
var CURRENT_VERSION = "marketing_sms_v1";
var MARKETING_SMS_CONSENT = {
	version: CURRENT_VERSION,
	...CONSENT_VERSIONS[CURRENT_VERSION]
};
var EmailDisclaimerText = ({ analyticsName }) => {
	return /* @__PURE__ */ React.createElement(Text, {
		tag: "p",
		typography: "$bodyXsmall",
		whiteSpace: "normal",
		$largerThanSM: { whiteSpace: "nowrap" }
	}, /* @__PURE__ */ React.createElement(MARKETING_SMS_CONSENT.CtaAgreementLinked, {
		ctaText: "Continue",
		tosAnalyticsName: `${analyticsName}-terms`,
		privacyAnalyticsName: `${analyticsName}-privacy-policy`,
		linkProps: {
			variant: "primary",
			size: "xsmall"
		}
	}));
};
var AccountFormHeader = ({ children, ...rest }) => {
	return /* @__PURE__ */ React.createElement(Text, {
		tag: "h1",
		typography: "$headerMedium",
		...rest,
		marginBottom: "$10x",
		textAlign: "left"
	}, children);
};
var AccountFormWrapper = (props) => {
	return /* @__PURE__ */ React.createElement(Box, {
		width: "100%",
		...props
	});
};
var FormWrapper = (props) => {
	return /* @__PURE__ */ React.createElement(Box, {
		width: "100%",
		flexDirection: "column",
		...props
	});
};
var Form$1 = styled.form`
  width: 100%;
  margin-top: 28px; /* $7x token equivalent */
`;
var Disclaimer = ({ children, desktopNoWrap = false, shouldRenderDisclaimerAboveCTA, ...props }) => {
	return /* @__PURE__ */ React.createElement(Box, props, /* @__PURE__ */ React.createElement(Text, {
		tag: "p",
		typography: "$bodyXsmall",
		color: "$contentSecondary",
		whiteSpace: "normal",
		$largerThanSM: desktopNoWrap ? { whiteSpace: "nowrap" } : void 0
	}, children));
};
//#endregion
export { AccountFormHeader, AccountFormWrapper, Disclaimer, EmailDisclaimerText, Form$1 as Form, FormWrapper, MARKETING_SMS_CONSENT };

